module.exports = __webpack_public_path__ + "static/media/blog.dd8eec4c.svg";